import { housevisitsOn, personasOnFlag } from '../../components/liveReport/reportBuilder2/editor/widgetBrowserGating'

// AI-CONTEXT: See docs/features/livereport-templates-deelnemer.md (T5)
// Welke templates een organisatie in de templatelijst ziet. Nodig omdat een
// deelnemertemplate zonder de module Deelnemers alleen meldingen toont.
// Dezelfde moduleregels als de widgetlijst (widgetBrowserGating), zodat een
// template en zijn widgets het eens zijn over 'module aan'.
// Dicht bij twijfel: `personasOn` is 'none' zolang de instellingen laden, en
// een onbekende module is niet aan.
// AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
// Elke lezer die templates kiest past deze regel toe (ook Decca: decca/reports/templateAvailableForTenant.js).
// AI-CONTEXT: See docs/pitfalls.md#dev-new-gate-field-reaches-one-reader

/**
 * De modules waarop een template zichtbaar gemaakt kan worden, met het label
 * dat de bouwer toont. Impact meten = `CompagnyMeta.ImpactFunctionality`, het
 * veld dat ook het impactmenu in de zijbalk aanzet: zo zien organisaties met
 * alleen Huishoudens (FIXtool) de impacttemplates niet.
 * @type {Array<{key: 'impactMeten'|'personas'|'housevisits', label: string}>}
 */
const TEMPLATE_MODULES = [
    { key: 'impactMeten', label: 'Impact meten' },
    { key: 'personas', label: 'Deelnemers' },
    { key: 'housevisits', label: 'Huishoudens' },
]

/** @type {Object<string, (flags: {housevisits?: unknown, personasOn?: unknown, impactFunctionality?: unknown}) => boolean>} */
const MODULE_ON = {
    impactMeten: (flags) => flags?.impactFunctionality === true,
    personas: (flags) => personasOnFlag(flags?.personasOn),
    housevisits: (flags) => housevisitsOn(flags?.housevisits),
}

/**
 * @param {{ RequiredModules?: Array<string> }} template - Een `LiveReports2`-doc met `IsTemplate`
 * @param {{ housevisits?: unknown, personasOn?: unknown, impactFunctionality?: unknown }} moduleFlags - Uit useSettings
 * @param {{ showAll?: boolean }} [options] - `showAll`: Deccos beheert de templates en ziet ze allemaal
 * @returns {boolean}
 */
const isTemplateAvailable = (template, moduleFlags, { showAll = false } = {}) => {
    if (showAll) return true
    const required = Array.isArray(template?.RequiredModules) ? template.RequiredModules : []
    return required.every((module) => Boolean(MODULE_ON[module]?.(moduleFlags)))
}

export { TEMPLATE_MODULES }
export default isTemplateAvailable
